/**
 * Created by tigran on 18.01.25
 **/

import React, { FC } from 'react';
import { IconType } from '@svg/index';
import { DEFAULT_ICON_PROPS } from '@svg/helpers';

type PhoneIconProps = IconType & {
  variant?: 'default' | 'profile';
};

export const PhoneIcon: FC<PhoneIconProps> = (props) => {
  const { width, height, color, variant = 'default' } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  const isProfile = variant === 'profile';

  return (
    <svg
      width={width}
      height={height}
      viewBox={isProfile ? '0 0 24 25' : '0 0 16 17'}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d={
          isProfile
            ? 'M14.8354 14.1896L13.0003 15.9999C12.0433 15.4229 11.1543 14.74 10.35 13.9641C9.57536 13.1585 8.89261 12.2694 8.31429 11.313L10.1229 9.47786C10.2324 9.36663 10.3064 9.22532 10.3354 9.07193C10.3644 8.91853 10.3471 8.75998 10.2857 8.61643L8.40001 4.221C8.32551 4.04769 8.19123 3.90691 8.02163 3.82431C7.85202 3.74171 7.65839 3.72279 7.47601 3.771L4.01829 4.68558C3.84562 4.73034 3.69325 4.83239 3.58613 4.97502C3.479 5.11764 3.42345 5.29241 3.42858 5.47072C3.64859 9.49224 5.32068 13.2972 8.13429 16.179C11.0166 18.9935 14.8226 20.6659 18.8452 20.8856C19.0236 20.8916 19.1988 20.8365 19.3417 20.7294C19.4847 20.6223 19.5868 20.4697 19.6312 20.2967L20.5449 16.8373C20.5933 16.655 20.5746 16.4614 20.4922 16.2918C20.4097 16.1221 20.269 15.9878 20.0957 15.9133L15.6994 14.0284C15.5558 13.9662 15.3967 13.9482 15.2428 13.977C15.0889 14.0057 14.947 14.0797 14.8354 14.1896Z'
            : 'M9.89028 9.75031L8.66685 10.9572C8.02886 10.5725 7.43617 10.1172 6.89999 9.60002C6.38357 9.06295 5.92839 8.47017 5.54285 7.83259L6.74857 6.60916C6.82159 6.53501 6.87091 6.4408 6.89024 6.33854C6.90957 6.23628 6.89805 6.13057 6.85714 6.03488L5.59999 3.10459C5.55033 2.98905 5.46081 2.89519 5.34774 2.84013C5.23467 2.78506 5.10558 2.77245 4.98399 2.80459L2.67885 3.41431C2.56374 3.44415 2.46216 3.51218 2.39074 3.60727C2.31932 3.70235 2.28229 3.81886 2.28571 3.93773C2.43238 6.61875 3.54711 9.15541 5.42285 11.0766C7.34438 12.9529 9.88173 14.0679 12.5634 14.2143C12.6824 14.2183 12.7992 14.1816 12.8945 14.1102C12.9898 14.0388 13.0578 13.937 13.0874 13.8217L13.6966 11.5154C13.7289 11.3939 13.7164 11.2648 13.6614 11.1518C13.6065 11.0387 13.5127 10.9491 13.3971 10.8994L10.4663 9.64288C10.3705 9.60137 10.2645 9.58942 10.1619 9.60856C10.0592 9.6277 9.96467 9.67706 9.89028 9.75031Z'
        }
        stroke={color}
        strokeWidth={isProfile ? 2.05714 : 1.37143}
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
    </svg>
  );
};
